const validateEmail = (email) => {
  const test =
    /^([a-zA-Z0-9_-]+\.)*[a-zA-Z0-9_-]+@[a-z0-9_-]+(\.[a-z0-9_-]+)*\.[a-z]{2,6}$/.test(
      email
    );
  return test;
};

export default validateEmail;
